import React from "react";
import { useSearchParams } from "react-router-dom";
import WholesaleWizard from "../components/wholesale/WholesaleWizard";
import { IMAGES, WHOLESALE_COMMODITIES, decodeMix } from "../mock";

export default function WholesalePage() {
  const [params] = useSearchParams();
  const sharedMix = decodeMix(params.get("case"));
  const initial = sharedMix ? ["wine"] : WHOLESALE_COMMODITIES.map((c) => c.id).filter((id) => id === params.get("commodity"));

  return (
    <main className="bg-[#1f4a33] min-h-screen" data-testid="wholesale-page">
      <section className="relative overflow-hidden grain pt-36 md:pt-44 pb-40 md:pb-56">
        <img src={IMAGES.coffee.drying} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#10271a]/70 via-[#10271a]/40 to-[#1f4a33]" />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 text-[#f6f1e7]">
          <p className="text-[#b08a5f] text-xs tracking-[0.25em] uppercase mb-6">Wholesale · Trade Desk</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.0] max-w-3xl">
            Build your <em className="italic text-[#e9d9bf]">supply.</em>
          </h1>
          <p className="mt-6 text-[#f6f1e7]/75 text-lg max-w-xl leading-relaxed">
            {sharedMix ? "A colleague has shared a tasting case with you. Review the bottles, tweak if you like, then send the enquiry." : "Choose the commodities, set indicative grades and volumes, and our trade desk will come back with an offer — no obligation."}
          </p>
        </div>
      </section>
      <section className="relative -mt-28 md:-mt-40 pb-24 md:pb-32">
        <div className="mx-auto max-w-[1100px] px-4 md:px-10 shadow-[0_40px_80px_-30px_rgba(16,39,26,0.6)] rounded-[2rem]">
          <WholesaleWizard initial={initial} sharedMix={sharedMix} />
        </div>
      </section>
    </main>
  );
}
